import { TurnPhase } from "~/business";

export const translateEn = {
  phases: {
    [TurnPhase.RoundStart]: "Start of round",
    [TurnPhase.Play]: "Play",
    [TurnPhase.Reveal]: "Reveal",
    [TurnPhase.Shop]: "Shop",
    [TurnPhase.CombatStart]: "Combat",
    [TurnPhase.CombatEnd]: "Conflict victory",
    [TurnPhase.EndGame]: "End game",
    [TurnPhase.Cleanup]: "End of round",
  },
};
